const KEYS = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT',
  FREE_SHIPPING: 'FREE_SHIPPING',
};

export const COUPON_TYPE = KEYS;

const LIST = Object.keys(KEYS);

const COUPON_TYPE_OPTIONS = LIST.map((item) => ({
  label: `COUPON_TYPE.${item}`,
  value: item,
}));

export default COUPON_TYPE_OPTIONS;
